export default function formatDate(dateString) {
  const date = new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
  // convert MM/DD/YYYY to MM-DD-YYYY
  return date.replace(/\//g, '-');
}
